import BoldSmallText from '@/components/BoldSmallText';
import RegularText from '@/components/RegularText';
import { jsonTimeZone } from '@/constants/timeZone';
import { handleSaveWidgetSettings, widgetSettingSelector } from '@/redux/slice/widget.slice';
import { BlockStack, Box, Select } from '@shopify/polaris';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

export const WidgetTimeZone = () => {
  const { t } = useTranslation('widget_settings');
  const widgetSettings = useSelector(widgetSettingSelector);
  const dispatch = useDispatch();

  const optionTimeZone = useMemo(() => {
    return Object.entries(jsonTimeZone).map(([key, value]) => ({
      label: value,
      value: key,
    }));
  }, []);
  return (
    <BlockStack gap={'300'}>
      <Box>
        <BoldSmallText>{t('widgetDesign.general.timezone.title')}</BoldSmallText>
        <RegularText tone="subdued">{t('widgetDesign.general.timezone.helpText')}</RegularText>
      </Box>
      <Select
        label=""
        labelHidden
        options={optionTimeZone}
        value={widgetSettings.timeZone || ''}
        onChange={(value) => {
          dispatch(handleSaveWidgetSettings({ timeZone: value }));
        }}
      />
    </BlockStack>
  );
};
